// import React from "react";
// import "./OfferBanner.css";

// const OfferBanner = () => {
//   return (
// <section className="offer-banner">
//   <video className="offer-video" autoPlay muted loop playsInline poster="/placeholder.jpg">
//     <source src="https://cdn.pixabay.com/video/2024/07/03/219278_tiny.mp4" type="video/mp4" />
//     Your browser doesn’t support video.
//   </video>
//   <div className="offer-text">
//     <h2>Festive Sparkle Deal!</h2>
//     <p>Limited offer: 25% off selected gold & diamond pieces</p>
//     <button className="shop-now">Shop Now</button>
//   </div>
// </section>

//   );
// };

// export default OfferBanner;


import React, { useEffect, useState } from "react";
import axios from "axios"; // Import axios for API requests
import "./OfferBanner.css";

const OfferBanner = () => {
  const [bannerData, setBannerData] = useState({
    video: "",
    heading: "",
    subtitle: ""
  });

  useEffect(() => {
    // Fetch Offer Banner data from API
    const fetchBannerData = async () => {
      try {
        const response = await axios.get('https://spinelleapi.emedha.in/admin/advertise/get/advertise');
        const offerBannerData = response.data.data.find(ad => ad.type === "Offer Banner");

        if (offerBannerData) {
          setBannerData({
            video: offerBannerData.video,
            heading: offerBannerData.heading,
            subtitle: offerBannerData.subtitle
          });
        }
      } catch (error) {
        console.error("Error fetching offer banner data:", error);
      }
    };

    fetchBannerData();
  }, []);

  return (
    <section className="offer-banner">
      {bannerData.video ? (
        <video className="offer-video" autoPlay muted loop playsInline poster="/placeholder.jpg">
          <source src={bannerData.video} type="video/mp4" />
          Your browser doesn’t support video.
        </video>
      ) : (
        <div>Loading video...</div>
      )}
      <div className="offer-text">
        <h2>{bannerData.heading || "Loading..."}</h2>
        <p>{bannerData.subtitle || "Please wait, loading details..."}</p>
        <button className="shop-now">Shop Now</button>
      </div>
    </section>
  );
};

export default OfferBanner;
